// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

export const S = {
  TabButton: styled.div`
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
    letter-spacing: 0.29px;
    color: #ef8200;
    text-align: center;
    width: 100%;
    height: 100%;
    padding: 22px 0;
    cursor: pointer;
	`
}
